import { showNotification as showNotificationKit } from '@invent/wl-ui-kit';

import { NotificationWidget } from '@/src/domains/widgets/components/platform-widgets/notification-widget';
import { StyledNotificationsContainer } from './styled';
import type { ShowNotificationT } from '@invent/shared-types';

export const CONTAINER_ID = 'wlabel-platform-container-notifications';

export const showNotification: ShowNotificationT = (type, content, options) => {
  const { refreshHandler, ...toastOptions } = options ?? {};

  showNotificationKit(type, content, {
    ...toastOptions,
    ToastComponent: NotificationWidget,
    containerId: CONTAINER_ID
  });
};

export const NotificationsContainer = StyledNotificationsContainer;
